import getLocale from './getLocale'

const getAlgoliaIndex = (locale?: string) => {
  return `API_${process.env.NEXT_PUBLIC_APP_ENVIRONMENT === 'production' ? '' : 'PREPROD_'}${getLocale(locale)}_products`
}

export default getAlgoliaIndex
